// extracted by mini-css-extract-plugin
module.exports = {"productTitle":"styles__productTitle___AphXA","versions":"styles__versions___1R9bm"};